import { render, staticRenderFns } from "./QuestionSort.vue?vue&type=template&id=20bc51fc&scoped=true&"
import script from "./QuestionSort.vue?vue&type=script&lang=js&"
export * from "./QuestionSort.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSort.vue?vue&type=style&index=0&id=20bc51fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bc51fc",
  null
  
)

export default component.exports